
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well/[region]",
      function () {
        return require("private-next-pages/well/[region]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/well/[region]"])
      });
    }
  